/**
Author - Brijesh Pandey
Git - https://bitbucket.org/__brijesh/
**/

import Hero from "./Hero";

export default Hero;
